import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { decorationNode } from '../editor/editor-utils/common-editor-utils';
import { Editable, withReact, Slate } from '@seafile/slate-react';
import '../editor/code-highlight-package';
import { createEditor } from 'slate';
import { renderNode, renderLeaf } from '../utils/render-slate';

var withVoid = function withVoid(editor) {
  var isVoid = editor.isVoid;

  editor.isVoid = function (element) {
    return element.type === 'image' || element.type === 'formula' ? true : isVoid(element);
  };

  return editor;
};

var withInline = function withInline(editor) {
  var isInline = editor.isInline;

  editor.isInline = function (element) {
    return element.type === 'link' || element.type === 'image' ? true : isInline(element);
  };

  return editor;
};

var SlateViewer = /*#__PURE__*/function (_React$Component) {
  _inherits(SlateViewer, _React$Component);

  var _super = _createSuper(SlateViewer);

  function SlateViewer(props) {
    var _this;

    _classCallCheck(this, SlateViewer);

    _this = _super.call(this, props);
    _this.editor = withInline(withVoid(withReact(createEditor())));
    window.viewer = _this.editor;
    return _this;
  }

  _createClass(SlateViewer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          value = _this$props.value,
          renderDiffElement = _this$props.renderDiffElement,
          renderDiffLeaf = _this$props.renderDiffLeaf;
      return /*#__PURE__*/React.createElement("div", {
        className: "article"
      }, /*#__PURE__*/React.createElement(Slate, {
        editor: this.editor,
        value: value
      }, /*#__PURE__*/React.createElement(Editable, {
        readOnly: true,
        className: 'viewer-component',
        decorate: decorationNode,
        renderElement: renderDiffElement ? renderDiffElement : renderNode,
        renderLeaf: renderDiffLeaf ? renderDiffLeaf : renderLeaf
      })));
    }
  }]);

  return SlateViewer;
}(React.Component);

export default SlateViewer;